import { createSlice } from "@reduxjs/toolkit";

const reportDetails = createSlice({
    name: "reportDetails",
    initialState: {
        reportDetails: {},
        selectedAccountId: null
    },
    reducers: {
        setReportDetails: (state, { payload }) => {
            state.reportDetails = payload;
        },
        setSelectedAccount: (state, { payload }) => {
            state.selectedAccountId = payload;
        }
    }
});

export const { setReportDetails, setSelectedAccount } = reportDetails.actions;

export default reportDetails.reducer;